<template>
  <div>
    <!-- 제목 -->
    <v-sheet outlined class="d-flex align-center ma-2 px-4" height="60">
      <font class="font-weight-bold text-h6 grey--text text--darken-2">라피아 예약 스케줄</font>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet class="ma-2 pa-4" outlined>
      <!-- 날짜 선택 -->
      <v-sheet class="d-flex justify-space-between align-center" style="min-width: 1030px; max-width: 1280px">
        <div class="d-flex align-center">
          <DateSelector :color="$vuetify.theme.currentTheme.primary" :width="330" class="mt-0 mb-4 mr-4" @dateUpdated="dateUpdated_handler" />
        </div>
        <div class="d-flex align-center font-weight-bold text-darken-2">
          총 예약 수: {{ this.reservation_list.length }} 건
          <v-checkbox v-model="showReservedOnly" class="shrink mt-0 ml-4" label="Active promotion" color="primary" hide-details dense></v-checkbox>
        </div>
      </v-sheet>

      <!-- 시간테이블 -->
      <div style="overflow-x: auto; width: 100%">
        <table class="timeTable">
          <!-- 헤더 행 추가 -->
          <thead>
            <tr>
              <th style="width: 100px; background: rgba(195, 126, 120, 0.15); position: sticky; left: 0; z-index: 2">시간</th>
              <th
                v-for="promotion in visiblePromotions"
                :key="promotion.code"
                :style="`min-width: ${promotion.code === 'default' ? '440px' : '220px'}; background: rgba(195, 126, 120, 0.1); padding: 8px;`"
              >
                {{ promotion.name }}<br />
                <span class="text-caption">예약 수 : {{ promotion.reservationCount || 0 }} 건</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in timeTable" :key="item.time">
              <!-- 시간 -->
              <td style="height: 110px; width: 100px; background: rgba(195, 126, 120, 0.15); text-align: center; position: sticky; left: 0; z-index: 1">
                <p class="mb-0">
                  {{ item.time }}
                </p>
              </td>

              <!-- 프로모션별 예약 현황 -->
              <td v-for="promotion in visiblePromotions" :key="promotion.code" :style="`height: 110px; min-width: ${promotion.code === 'default' ? '440px' : '220px'}; padding: 2px;`">
                <!-- 해당 시간, 해당 프로모션에 예약이 있는 경우 -->
                <div v-if="getReservationsByTimeAndPromotion(item.time, promotion).length > 0" class="d-flex">
                  <v-sheet
                    v-for="reservation in getReservationsByTimeAndPromotion(item.time, promotion)"
                    :key="reservation.id"
                    height="106"
                    width="216"
                    class="rounded-10 primary lighten-1 white--text text-center mr-1 d-flex flex-column justify-center"
                    :style="{ backgroundColor: getReservationStyle(reservation) }"
                    @click="detailCastle(reservation)"
                  >
                    <div class="d-flex align-center">
                      <v-img :src="getConceptImageSrc(reservation.concept)" height="106" width="80" class="rounded-10 pa-2"></v-img>
                      <div class="flex-grow-1 text-left ml-2">
                        <p class="text-body-2 mt-1 mb-0 text-truncate px-1" :style="reservation.name == null ? 'color:red;' : ''" style="line-height: 16px">
                          {{ reservation.name ? $getUserDisplayName(reservation.name) : reservation.user_id }}
                        </p>
                        <div class="text-caption font-weight-medium mt-1">{{ getTicketName(reservation) }}{{ getOptionProductTitle(reservation) }}</div>
                        <div class="text-caption font-weight-bold">{{ reservation.concept }}</div>
                        <div v-if="!reservation.individual" class="text-caption font-weight-bold">촬영: {{ getShootingTime(reservation.time) }}</div>
                      </div>
                    </div>
                  </v-sheet>
                </div>
                <!-- 예약이 없는 경우 -->
                <div v-else style="height: 106px; background: #f9f9f9" class="d-flex align-center justify-center">
                  <span v-if="item.is_rest" style="color: #999">휴식</span>
                  <span v-else-if="item.memo" style="color: #666; font-size: 12px">{{ item.memo }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-sheet>

    <!-- 메모하기 (dialog) -->
    <v-dialog v-model="dialog.memo" width="440" content-class="rounded-xl">
      <v-sheet class="px-16 pt-8 pb-6">
        <!-- 제목 -->
        <p class="mb-6 font-weight-bold text-center" style="font-size: 24px">메모하기</p>

        <v-text-field class="rounded-15" outlined :disabled="selectedItem.is_rest" v-model="selectedItem.memo" counter="10"></v-text-field>
        <v-btn
          depressed
          class="rounded-15 d-block mx-auto px-16"
          :class="selectedItem.is_rest ? 'green white--text' : 'grey lighten-2'"
          @click="
            selectedItem.is_rest = !selectedItem.is_rest
            dialog.memo = false
          "
        >
          휴식
        </v-btn>

        <!-- 버튼 -->
        <div class="d-flex justify-center mt-4">
          <!-- 취소 -->
          <v-btn
            width="100"
            depressed
            color="grey lighten-3"
            class="font-weight-bold rounded-10 mr-3"
            @click="
              selectedItem.is_rest = false
              selectedItem.memo = ''
              dialog.memo = false
            "
          >
            비우기
          </v-btn>

          <!-- 제출 -->
          <v-btn width="100" dark depressed class="font-weight-bold rounded-10" @click="dialog.memo = false"> 입력 </v-btn>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- 예약 상세보기 (dialog) -->
    <v-dialog v-model="dialog.detail" width="1280" content-class="rounded-xl" :persistent="photoDeliveryState.uploading">
      <v-sheet class="reservation-detail">
        <header class="reservation-detail__header">
          <div class="reservation-detail__title-row">
            <h2>예약 상세보기</h2>
            <span class="reservation-detail__status">{{ selected_reservation.status || "상태 확인 중" }}</span>
          </div>
          <v-btn icon :disabled="photoDeliveryState.uploading" aria-label="예약 상세보기 닫기" @click="dialog.detail = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </header>

        <div class="reservation-detail__body">
          <aside class="reservation-detail__information">
            <section class="reservation-info-card">
              <h3>고객 정보</h3>
              <dl>
                <div>
                  <dt>예약자명</dt>
                  <dd>{{ $getUserDisplayName(selected_reservation.name) }}</dd>
                </div>
                <div>
                  <dt>전화번호</dt>
                  <dd>{{ selected_reservation.phone || "-" }}</dd>
                </div>
                <div>
                  <dt>이메일</dt>
                  <dd>{{ selected_reservation.email || "-" }}</dd>
                </div>
              </dl>
            </section>

            <section class="reservation-info-card">
              <h3>촬영 정보</h3>
              <dl>
                <div>
                  <dt>상품타입</dt>
                  <dd>{{ getTicketName(selected_reservation) }}</dd>
                </div>
                <div v-if="getOptionTitles(selected_reservation).length > 0">
                  <dt>옵션상품</dt>
                  <dd>{{ getOptionTitles(selected_reservation).join(" + ") }}</dd>
                </div>
                <div>
                  <dt>컨셉</dt>
                  <dd class="reservation-info-card__concept">
                    <span>{{ selected_reservation.concept || "-" }}</span>
                    <v-btn x-small depressed class="reservation-info-card__change" @click="openSelectConcept()">변경</v-btn>
                  </dd>
                </div>
                <div>
                  <dt>이용일</dt>
                  <dd>{{ selected_reservation.year }}. {{ selected_reservation.month }}. {{ selected_reservation.day }}. / {{ selected_reservation.time }}</dd>
                </div>
                <div>
                  <dt>작가</dt>
                  <dd>
                    <template v-if="selected_reservation.maker">
                      {{ $getUserDisplayName(selected_reservation.maker) }}
                      <template v-if="selected_reservation.staffUserId">({{ selected_reservation.staffUserId }})</template>
                    </template>
                    <template v-else>-</template>
                  </dd>
                </div>
                <div>
                  <dt>프로모션</dt>
                  <dd>{{ selected_reservation.promotionCode ? getPromotionName(selected_reservation.promotionCode) : "-" }}</dd>
                </div>
              </dl>
            </section>

            <section class="reservation-info-card">
              <h3>결제 정보</h3>
              <dl>
                <div>
                  <dt>결제일</dt>
                  <dd>{{ selected_reservation.created ? new Date(selected_reservation.created).toLocaleDateString() : "-" }}</dd>
                </div>
                <div>
                  <dt>상태</dt>
                  <dd class="reservation-info-card__paid">{{ selected_reservation.status || "-" }}</dd>
                </div>
                <div>
                  <dt>결제금액</dt>
                  <dd>{{ $toComma(selected_reservation.pay_amount || 0) }}원</dd>
                </div>
                <div>
                  <dt>취소가능금액</dt>
                  <dd v-if="selected_reservation.toss_id > 0">
                    {{ selected_reservation.type && selected_reservation.type.startsWith("현장") ? "현장결제" : $toComma(selected_reservation.balance_amount || 0) + "원" }}
                  </dd>
                  <dd v-else>현장 결제 처리</dd>
                </div>
              </dl>
            </section>
          </aside>

          <main class="reservation-detail__work">
            <h3 class="reservation-detail__work-title">
              {{ isPremiumPhotoDelivery(selected_reservation) ? "사진 전달" : "촬영사진" }}
            </h3>

            <section class="reservation-detail__memo">
              <label for="reservation-detail-memo">메모</label>
              <v-text-field
                id="reservation-detail-memo"
                v-model="selected_reservation.memo"
                outlined
                dense
                hide-details
                maxlength="512"
                placeholder="메모를 입력하세요"
              />
              <v-btn outlined color="#7d1832" class="reservation-detail__memo-save" @click="saveReservationMemo">저장</v-btn>
            </section>

            <PremiumPhotoDeliveryUpload
              v-if="isPremiumPhotoDelivery(selected_reservation)"
              ref="premiumPhotoDelivery"
              :reservation="selected_reservation"
              :key="`premium-delivery-${selected_reservation.id}`"
              @state-change="handlePhotoDeliveryState"
            />
            <QRCodeGallery v-else :selected_reservation="selected_reservation" />
          </main>
        </div>

        <footer class="reservation-detail__footer">
          <div class="reservation-detail__footer-left">
            <v-btn outlined width="116" class="reservation-detail__close" :disabled="photoDeliveryState.uploading" @click="dialog.detail = false">닫기</v-btn>
            <v-btn outlined width="124" color="#7d1832" @click="openCancelDialog()" :disabled="reservation_cancel_disabled || photoDeliveryState.uploading">예약취소</v-btn>
          </div>
        </footer>
      </v-sheet>
    </v-dialog>

    <!-- 환불 다이얼로그 -->
    <v-dialog v-model="dialog.cancel" width="460" content-class="rounded-xl" persistent>
      <v-card>
        <v-card-title>예약 취소</v-card-title>
        <v-divider></v-divider>
        <v-card-subtitle class="black--text text-body-1 font-weight-medium mt-2">{{ $getUserDisplayName(selected_reservation.name) }} 예약 취소</v-card-subtitle>
        <v-card-text class="warning--text">취소 최대금액 {{ $toComma(selected_reservation.balance_amount || 0) }}원</v-card-text>

        <v-card-text>
          <v-text-field label="취소금액" dense outlined type="number" hide-spin-buttons v-model="cancelAmount" :rules="[canCancelAmount]" clearable></v-text-field>
          <div class="d-flex justify-end">
            <v-btn color="primary" class="text-center" text @click="cancelAmount = selected_reservation.balance_amount">전액</v-btn>
          </div>

          <v-card-subtitle class="info--text text-body-1 font-weight-medium mt-2">취소 사유</v-card-subtitle>
          <v-text-field class="rounded-15" outlined v-model="cancelReason" counter="100" height="100"></v-text-field>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-spacer />
          <v-btn class="px-4" depressed outlined @click="dialog.cancel = false" :disabled="reservation_canceling">닫기</v-btn>
          <v-btn class="px-4 mx-4" color="red" dark depressed @click="reservation_cancel" :loading="reservation_canceling">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConceptSelectDialog
      :visible="show_concept_select"
      :title="selected_reservation.concept"
      @close="show_concept_select = false"
      @input="(e) => (show_concept_select = e)"
      :key="'concept' + show_concept_select_componentKey"
      @apply="changeConcept"
    />
  </div>
</template>
<script>
import { computed } from "vue"
import DateSelector from "@/components/DateSelector"
import payletterService from "@/api/payletter-service"
import { mapActions, mapState } from "vuex"
import { SHOOTING_TIME } from "@/constant"
import ConceptSelectDialog from "@/views/components/ConceptSelectDialog"
import QRCodeGallery from "@/views/admin/qrcode/QRCodeGallery"
import PremiumPhotoDeliveryUpload from "@/views/admin/qrcode/PremiumPhotoDeliveryUpload"

export default {
  components: {
    DateSelector,
    ConceptSelectDialog,
    QRCodeGallery,
    PremiumPhotoDeliveryUpload,
  },
  provide() {
    return {
      concepts: computed(() => this.concepts),
    }
  },

  data: () => ({
    date: null,

    timeTable: [
      { time: "10:00", is_reservation: false, memo: "", is_rest: false },
      { time: "10:15", is_reservation: false, memo: "", is_rest: false },
      { time: "10:30", is_reservation: false, memo: "", is_rest: false },
      { time: "10:45", is_reservation: false, memo: "", is_rest: false },
      { time: "11:00", is_reservation: false, memo: "", is_rest: false },
      { time: "11:15", is_reservation: false, memo: "", is_rest: false },
      { time: "11:30", is_reservation: false, memo: "", is_rest: false },
      { time: "11:45", is_reservation: false, memo: "", is_rest: false },
      { time: "12:00", is_reservation: false, memo: "", is_rest: false },
      { time: "12:15", is_reservation: false, memo: "", is_rest: false },
      { time: "12:30", is_reservation: false, memo: "", is_rest: false },
      { time: "12:45", is_reservation: false, memo: "", is_rest: false },
      { time: "13:00", is_reservation: false, memo: "", is_rest: false },
      { time: "13:15", is_reservation: false, memo: "", is_rest: false },
      { time: "13:30", is_reservation: false, memo: "", is_rest: false },
      { time: "13:45", is_reservation: false, memo: "", is_rest: false },
      { time: "14:00", is_reservation: false, memo: "", is_rest: false },
      { time: "14:15", is_reservation: false, memo: "", is_rest: false },
      { time: "14:30", is_reservation: false, memo: "", is_rest: false },
      { time: "14:45", is_reservation: false, memo: "", is_rest: false },
      { time: "15:00", is_reservation: false, memo: "", is_rest: false },
      { time: "15:15", is_reservation: false, memo: "", is_rest: false },
      { time: "15:30", is_reservation: false, memo: "", is_rest: false },
      { time: "15:45", is_reservation: false, memo: "", is_rest: false },
      { time: "16:00", is_reservation: false, memo: "", is_rest: false },
      { time: "16:15", is_reservation: false, memo: "", is_rest: false },
      { time: "16:30", is_reservation: false, memo: "", is_rest: false },
      { time: "16:45", is_reservation: false, memo: "", is_rest: false },
      { time: "17:00", is_reservation: false, memo: "", is_rest: false },
      { time: "17:15", is_reservation: false, memo: "", is_rest: false },
      { time: "17:30", is_reservation: false, memo: "", is_rest: false },
      { time: "17:45", is_reservation: false, memo: "", is_rest: false },
      { time: "18:00", is_reservation: false, memo: "", is_rest: false },
      { time: "18:15", is_reservation: false, memo: "", is_rest: false },
      { time: "18:30", is_reservation: false, memo: "", is_rest: false },
      { time: "18:45", is_reservation: false, memo: "", is_rest: false },
      { time: "19:00", is_reservation: false, memo: "", is_rest: false },
      { time: "19:15", is_reservation: false, memo: "", is_rest: false },
      { time: "19:30", is_reservation: false, memo: "", is_rest: false },
      { time: "19:45", is_reservation: false, memo: "", is_rest: false },
      { time: "20:00", is_reservation: false, memo: "", is_rest: false },
      { time: "20:15", is_reservation: false, memo: "", is_rest: false },
      { time: "20:30", is_reservation: false, memo: "", is_rest: false },
      { time: "20:45", is_reservation: false, memo: "", is_rest: false },
      { time: "21:00", is_reservation: false, memo: "", is_rest: false },
      { time: "21:15", is_reservation: false, memo: "", is_rest: false },
      { time: "21:30", is_reservation: false, memo: "", is_rest: false },
      { time: "21:45", is_reservation: false, memo: "", is_rest: false },
      { time: "22:00", is_reservation: false, memo: "", is_rest: false },
    ],

    selectedItem: {},
    concepts: [],

    reservation_list: [
      {
        time: "",
        name: "",
      },
    ],

    selected_reservation: {},

    promotions: [],

    dialog: {
      memo: false,
      detail: false,
      cancel: false,
    },

    reservation_canceling: false, // 예약 취소 진행중

    show_concept_select: false,
    show_concept_select_componentKey: 0,

    promotionsWithReservations: [],
    showReservedOnly: false,

    cancelAmount: 0,
    cancelReason: "",

    photoDeliveryState: {
      uploading: false,
    },
  }),

  async mounted() {
    try {
      this.concepts = await this.loadConceptsAll()
      this.promotions = await this.getAllPromotions()

      // 프로모션 헤더 초기화
      this.initializePromotionHeaders()
    } catch (e) {}
  },

  watch: {
    date() {
      // 라피아캐슬 예약 불러오기
      this.loadCastleTime()
    },
  },

  computed: {
    ...mapState(["lafia_user"]),
    adminUserId() {
      return this.lafia_user.user_id
    },
    reservation_cancel_disabled() {
      console.log(this.selected_reservation)
      return this.selected_reservation.toss_id <= 0
    },
    visiblePromotions() {
      if (!this.showReservedOnly) {
        return this.promotionsWithReservations
      }

      return this.promotionsWithReservations.filter((promotion) => {
        return promotion.code === "default" || (promotion.reservationCount && promotion.reservationCount > 0)
      })
    },
  },

  methods: {
    ...mapActions(["loadConceptsAll"]),
    // DateSelector에서 date
    dateUpdated_handler(date) {
      this.date = date
    },

    // 라피아캐슬 예약 불러오기 - 모든 프로모션 데이터 가져오기
    loadCastleTime() {
      console.log("loadCastleTime - 모든 프로모션")
      this.$http
        .post("/api/reservation/select/specific/day/category/all", {
          params: {
            category: "라피아캐슬",
            year: this.date.year(),
            month: this.date.month() + 1,
            day: this.date.date(),
          },
        })
        .then((res) => {
          console.log(this.date.format("YYYY년 MM월 DD일"))
          console.log("예약 목록:", res.data)
          this.reservation_list = res.data
          // 예약 정보를 기반으로 프로모션 헤더를 재정렬
          this.initializePromotionHeaders()
        })
    },

    // 프로모션 헤더 초기화
    initializePromotionHeaders() {
      // 예약수 계산 (없음/빈 문자열은 default로 계산)
      const reservationCounts = this.reservation_list
        .map((r) => ({
          ...r,
          individual: r.productType === "premium" ? (r.promotionCode ? r.promotionCode.toLowerCase() : null) : r.individual ? r.individual.toLowerCase() : null,
          promotionCode: r.promotionCode ? r.promotionCode.toLowerCase() : null,
        }))
        .reduce((acc, r) => {
          if (r.individual && r.individual !== "") {
            acc[r.individual] = (acc[r.individual] || 0) + 1
          } else {
            acc["default"] = (acc["default"] || 0) + 1
          }
          return acc
        }, {})

      // 기본(default) 프로모션 항목 구성
      const defaultPromotion = {
        name: "라피아(메이커샷)",
        code: "default",
        createdAt: null,
        reservationCount: reservationCounts["default"] || 0,
      }

      // 기타 프로모션에 예약수/생성일 부여
      const otherPromotions = (this.promotions || [])
        .filter((p) => p.isIndividual === 1)
        .map((p) => ({
          ...p,
          createdAt: p.createdAt || p.created || null,
          reservationCount: reservationCounts[p.code.toLowerCase()] || 0,
        }))
      console.log("otherPromotions", otherPromotions)

      const list = [defaultPromotion, ...otherPromotions]

      list.sort((a, b) => {
        if (a.code === "default" && b.code !== "default") return -1
        if (b.code === "default" && a.code !== "default") return 1

        // 이름 오름차순
        return a.name.localeCompare(b.name)
      })

      this.promotionsWithReservations = list
    },

    // 특정 시간과 프로모션에 대한 예약 가져오기
    getReservationsByTimeAndPromotion(time, promotion) {
      return this.reservation_list.filter((reservation) => {
        if (reservation.time !== time) return false

        if (promotion.isIndividual) {
          if (reservation.productType === "premium") {
            return (reservation.promotionCode ?? "").toLowerCase() == promotion.code.toLowerCase()
          } else {
            return (reservation.individual ?? "").toLowerCase() == promotion.code.toLowerCase()
          }
        } else {
          if (reservation.productType === "premium") return false
          return !reservation.individual || reservation.individual === null || reservation.individual === undefined || reservation.individual === ""
        }
      })
    },

    openMemo(item) {
      this.selectedItem = item
      this.dialog.memo = true
    },

    // 주문 상세
    detailCastle(reservation) {
      this.selected_reservation = { ...reservation }
      this.photoDeliveryState = {
        uploading: false,
      }
      this.dialog.detail = true
    },

    handlePhotoDeliveryState(state) {
      this.photoDeliveryState = {
        uploading: Boolean(state && state.uploading),
      }
    },

    isPremiumPhotoDelivery(reservation) {
      return reservation && reservation.productType === "premium"
    },

    isOnlineReservation(reservation) {
      if (!reservation.type) return true
      return !reservation.type.startsWith("현장")
    },
    ///:style="'{ background-color: `${getReservationColor(reservation)}` }'"
    getReservationStyle(reservation) {
      if (reservation.promotionCode && reservation.promotionCode !== "default" && this.hasPromotion(reservation.promotionCode)) {
        return "#865491 !important"
      } else if (this.isOnlineReservation(reservation)) {
        return "#a26867 !important"
      } else {
        return "#54916c !important"
      }
    },

    hasPromotion(promotionCode) {
      return this.promotions.find((p) => p.code.toLowerCase() == promotionCode.toLowerCase())
    },

    getPromotionName(promotionCode) {
      const promotion = this.promotions.find((p) => p.code.toLowerCase() == promotionCode.toLowerCase())
      return promotion && promotion.name ? promotion.name : promotionCode
    },

    // 취소 다이얼로그 열기
    openCancelDialog() {
      this.cancelAmount = 0
      this.cancelReason = ""
      this.dialog.cancel = true
    },

    // 취소 금액 유효성 검사
    canCancelAmount(value) {
      if (this.selected_reservation.balance_amount) {
        if (Number(value) >= 0 && Number(value) <= this.selected_reservation.balance_amount) {
          return true
        } else {
          return "금액을 확인하세요"
        }
      } else {
        return "잘못된 항목입니다."
      }
    },

    // 예약 취소하기
    reservation_cancel: _.debounce(async function () {
      if (!this.selected_reservation) {
        alert("선택한 항목이 없습니다.")
        return
      }

      if (this.selected_reservation.type === "현장예약") {
        // 스케줄만 취소
        if (confirm("현장 결제한 사항입니다. 스케줄을 취소하시겠습니까?")) {
          const response = await this.$http.post("/api/order/update/status", {
            params: {
              id: this.selected_reservation.order_id,
              status: "취소완료",
            },
          })
          if (response.data.affectedRows) {
            alert("예약이 정상적으로 취소되었습니다.")
            this.loadCastleTime()
            this.dialog.detail = false
            this.dialog.cancel = false
          }
        }
        return
      }

      if (!this.cancelAmount || !this.selected_reservation || !this.selected_reservation.balance_amount) {
        alert("취소 가능한 금액이 없습니다.")
        return
      }

      if (this.cancelAmount > this.selected_reservation.balance_amount) {
        alert("취소 가능 금액보다 큽니다. 금액을 다시 입력해 주세요.")
        return
      }

      let confirmMessage = `해당 금액 ${this.cancelAmount}원 취소를 진행하시겠습니까?`

      if (confirm(confirmMessage)) {
        try {
          this.reservation_canceling = true

          let params = {
            orderListId: this.selected_reservation.order_id,
            paymentKey: this.selected_reservation.paymentKey,
            cancelAmount: this.cancelAmount,
            cancelReason: this.cancelReason || "관리자 취소",
            isAdmin: true,
            isAll: this.selected_reservation.balance_amount === this.cancelAmount,
            adminId: this.adminUserId,
          }

          const orderFunc = (params) => (this.selected_reservation.payment_type === "payletter" ? payletterService.cancelOrder(params) : this.$http.post("/api/payments/toss/order/cancel", params))

          const response = await orderFunc(params)

          alert("예약이 정상적으로 취소되었습니다.")
          this.loadCastleTime()
          this.dialog.detail = false
          this.dialog.cancel = false

          this.$http.post("/api/coupon/cancelUseCoupon", {
            toss_id: this.selected_reservation.toss_id.toString(),
            user_id: this.selected_reservation.user_id,
          })
        } catch (e) {
          console.log(e)
          alert("오류가 발생하여 취소처리가 완료되지 않았습니다. " + e.toString())
        } finally {
          this.reservation_canceling = false
        }
      }
    }, 500),

    saveReservationMemo: _.debounce(function () {
      this.$http
        .post("/api/reservation/update/memo", {
          memo: this.selected_reservation.memo ?? "",
          id: this.selected_reservation.id,
        })
        .then((res) => {
          if (res.data.affectedRows) {
            alert("저장하였습니다.")
          } else {
            alert("저장에 실패하였습니다.")
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }, 500),

    getTicketName(item) {
      const promotionCode = item.promotionCode && item.promotionCode.trim() !== "" ? item.promotionCode : "default"
      const promotion = this.promotions.find((p) => p.code.toLowerCase() === promotionCode.toLowerCase())
      //console.log("getTicketName item:",item)
      //console.log("getTicketName promotion", promotion)

      // optionType이 JSON 형식인지 확인하고 id 추출
      let optionId = item.optionType
      if (typeof item.optionType === "string" && item.optionType.startsWith("{")) {
        try {
          const optionData = JSON.parse(item.optionType)
          optionId = optionData.id
        } catch (e) {
          // JSON 파싱 실패시 원본 값 사용
          console.error("Failed to parse optionType JSON:", e)
        }
      }

      // products 필드가 있고 파싱 가능한 경우
      if (promotion && promotion.products) {
        try {
          const products = JSON.parse(promotion.products)
          const product = products.find((p) => p.id === optionId)
          if (product && product.title?.kr) {
            let title = product.title.kr

            // product.type이 'group'이면 인원수 표시
            if (product.type === "group") {
              title = `${title}(인원 ${item.cloth}명)`
            }

            return title
          }
        } catch (e) {
          // JSON 파싱 에러 무시하고 기존 방식 사용
        }
      }

      // products가 없거나 해당 상품이 없는 경우 기존 방식 사용
      let productName = "이용권"
      switch (optionId) {
        case "option1":
          productName = "솔로샷"
          break
        case "option2":
          productName = "솔로샷 듀얼"
          break
        case "option3":
          productName = "그룹샷 " + item.cloth + "명"
          break
        case "option4":
          productName = "2인 할인 팩"
          break
        case "option5":
          productName = "3인 할인 팩"
          break
        case "option6":
          productName = "4인 할인 팩"
          break
      }
      return productName
    },

    getOptionProductTitle(item) {
      if (!item.options || item.options.trim() === "") {
        return ""
      }
      try {
        // options는 JSON 배열 형식의 문자열
        const options = JSON.parse(item.options)
        if (options.length > 0) {
          return " (+옵션)"
        } else {
          return ""
        }
      } catch (e) {
        console.error("getOptionProductTitle error:", e)
        return ""
      }
    },

    getConceptImageSrc(conceptTitle) {
      try {
        console.log("getConceptImageSrc conceptTitle:", conceptTitle)
        if (!conceptTitle || this.concepts.length == 0) return require("@/assets/placeholder.jpg")
        const concept = this.concepts.find((c) => c.title === conceptTitle)
        if (!concept || !concept.pattern_1_image) return require("@/assets/placeholder.jpg")
        console.log("concept:", concept)
        return "/upload/concept/thumbnail_image/" + concept.pattern_1_image
      } catch (e) {
        console.error("getConceptImageSrc error:", e)
        return require("@/assets/placeholder.jpg")
      }
    },

    getShootingTime(time) {
      const [hours, minutes] = time.split(":").map(Number)
      const totalMinutes = hours * 60 + minutes + SHOOTING_TIME
      const endHours = Math.floor(totalMinutes / 60)
      const endMinutes = totalMinutes % 60
      const shootingtime = `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`
      return shootingtime
    },

    openSelectConcept() {
      this.show_concept_select = true
      this.show_concept_select_componentKey++
    },

    changeConcept(newConcept) {
      // 여기에 컨셉 변경 로직을 추가해야 함
      console.log("컨셉 변경 클릭:", newConcept)
      this.selected_reservation.concept = newConcept.title

      this.$http
        .post("/api/reservation/update/change_concept", {
          concept: newConcept.title,
          id: this.selected_reservation.id,
        })
        .then((res) => {
          if (res.data.affectedRows) {
            alert("저장하였습니다.")
          } else {
            alert("저장에 실패하였습니다.")
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },

    async getAllPromotions() {
      try {
        const response = await this.$http.post("/api/promotion/select/getAllProductsInfo")
        const promotions = response.data.map((promotion) => ({
          name: promotion.name,
          code: promotion.code,
          products: promotion.products,
          createdAt: promotion.created || null,
          isIndividual: promotion.isIndividual,
        }))
        return promotions
      } catch (e) {
        console.error("Error getting individual promotions:", e)
        return []
      }
    },

    getOptionTitles(reservation) {
      // options 필드가 없거나 빈 문자열이면 빈 배열 반환
      if (!reservation.options || reservation.options.trim() === "") {
        return []
      }

      try {
        // options는 JSON 배열 형식의 문자열
        const options = JSON.parse(reservation.options)

        // 각 옵션 상품의 제목을 추출
        return options
          .map((option) => {
            if (!option || !option.title) return ""

            let title = option.title

            // title이 문자열인 경우 JSON 파싱 시도
            if (typeof title === "string") {
              try {
                title = JSON.parse(title)
              } catch {
                return title
              }
            }

            // title이 객체인 경우 한국어 제목 반환
            if (typeof title === "object") {
              return title.kr || ""
            }

            return ""
          })
          .filter((title) => title)
      } catch (error) {
        console.error("Error parsing options:", error)
        return []
      }
    },
  },
}
</script>
<style scoped>
.timeTable {
  width: auto;
  min-width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
  text-align: center;
  font-weight: 500;
}

.timeTable tr td {
  padding: 4px 8px;
  height: 110px;
  cursor: pointer;
  border: 1px solid #ccc;
}

.reservation {
  cursor: pointer;
  background: #ffb19c;
  color: white;
  font-weight: 300;
}

.rest {
  cursor: pointer;
  background: #ccc;
  color: white;
  font-weight: 300;
}

/* 예약 상세보기 */
.reservation-detail {
  display: flex;
  overflow: hidden;
  max-height: 92vh;
  flex-direction: column;
  border-radius: 18px;
  background: #fff;
  color: #252220;
}

.reservation-detail__header {
  display: flex;
  flex: 0 0 auto;
  min-height: 88px;
  padding: 0 36px;
  border-bottom: 1px solid #e8e2de;
  align-items: center;
  justify-content: space-between;
}

.reservation-detail__title-row {
  display: flex;
  align-items: center;
  gap: 18px;
}

.reservation-detail__title-row h2 {
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  letter-spacing: -0.04em;
}

.reservation-detail__status {
  display: inline-flex;
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid #c79a45;
  border-radius: 7px;
  color: #9a6714;
  font-size: 13px;
  font-weight: 700;
  align-items: center;
}

.reservation-detail__body {
  display: grid;
  overflow-y: auto;
  min-height: 0;
  flex: 1 1 auto;
  grid-template-columns: minmax(390px, 470px) minmax(0, 1fr);
}

.reservation-detail__information {
  display: flex;
  padding: 26px 28px 30px 36px;
  border-right: 1px solid #e8e2de;
  flex-direction: column;
  gap: 14px;
}

.reservation-info-card {
  padding: 14px 16px 13px;
  border: 1px solid #ded4cd;
  border-radius: 8px;
  background: #fffdfa;
}

.reservation-info-card h3 {
  margin: 0 0 8px;
  padding-bottom: 9px;
  border-bottom: 1px solid #e6ddd7;
  font-size: 16px;
  line-height: 1.2;
}

.reservation-info-card dl {
  margin: 0;
}

.reservation-info-card dl > div {
  display: grid;
  min-height: 31px;
  grid-template-columns: 112px minmax(0, 1fr);
  align-items: center;
}

.reservation-info-card dt {
  color: #4f4945;
  font-size: 12px;
  font-weight: 700;
}

.reservation-info-card dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #252220;
  font-size: 13px;
  line-height: 1.45;
}

.reservation-info-card__concept {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.reservation-info-card__change {
  min-width: 46px !important;
  height: 25px !important;
  padding: 0 8px !important;
  border-radius: 6px;
  color: #665a53 !important;
}

.reservation-info-card__paid {
  color: #a36d12 !important;
  font-weight: 700;
}

.reservation-detail__work {
  min-width: 0;
  padding: 26px 36px 30px 30px;
}

.reservation-detail__work-title {
  margin: 0 0 18px;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: -0.03em;
}

.reservation-detail__memo {
  display: grid;
  padding-bottom: 22px;
  border-bottom: 1px solid #e6ddd7;
  grid-template-columns: 54px minmax(0, 1fr) 92px;
  align-items: center;
  gap: 10px;
}

.reservation-detail__memo label {
  font-size: 14px;
  font-weight: 700;
}

.reservation-detail__memo-save {
  height: 40px !important;
  border-radius: 6px;
  font-weight: 700;
}

.reservation-detail__footer {
  display: flex;
  flex: 0 0 auto;
  min-height: 82px;
  padding: 0 36px;
  border-top: 1px solid #e8e2de;
  background: #fffdfa;
  align-items: center;
  justify-content: space-between;
}

.reservation-detail__footer-left {
  display: flex;
  gap: 12px;
}

.reservation-detail__footer .v-btn {
  height: 48px;
  border-radius: 6px;
  font-weight: 700;
}

.reservation-detail__close {
  color: #3d3733 !important;
}

@media (max-width: 900px) {
  .reservation-detail {
    max-height: 90vh;
  }

  .reservation-detail__header {
    min-height: 74px;
    padding: 0 20px;
  }

  .reservation-detail__title-row h2 {
    font-size: 23px;
  }

  .reservation-detail__body {
    display: block;
  }

  .reservation-detail__information {
    padding: 20px;
    border-right: 0;
    border-bottom: 1px solid #e8e2de;
  }

  .reservation-detail__work {
    padding: 22px 20px 26px;
  }

  .reservation-detail__footer {
    min-height: 76px;
    padding: 0 20px;
  }
}

@media (max-width: 600px) {
  .reservation-detail__status {
    display: none;
  }

  .reservation-detail__memo {
    grid-template-columns: 1fr 78px;
  }

  .reservation-detail__memo label {
    grid-column: 1 / -1;
  }

  .reservation-detail__footer {
    box-sizing: border-box;
    flex: 0 0 76px;
    min-height: 76px;
    padding-top: 12px;
    padding-bottom: 12px;
    align-items: stretch;
  }

  .reservation-detail__footer-left {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .reservation-detail__footer .v-btn {
    width: 100% !important;
  }

}
</style>
